import { render, staticRenderFns } from "./info-banner.vue?vue&type=template&id=0de85500"
import script from "./info-banner.vue?vue&type=script&lang=js"
export * from "./info-banner.vue?vue&type=script&lang=js"
import style0 from "./info-banner.vue?vue&type=style&index=0&id=0de85500&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports